import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Usuario } from 'src/app/interfaces/usuario';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { environment } from 'src/environments/environment';

const correoRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
    selector: 'app-verification-code',
    templateUrl: './verification-code.component.html',
    styleUrls: ['./verification-code.component.scss']
})
export class VerificationCodeComponent implements OnInit {

  captchaIsLoaded: boolean;
  captchaSuccess: boolean;
  captchaIsExpired: boolean;
  captchaResponse: string;
  calveSitio: string;
  lang: string;

  formVer: FormGroup;
  usuario: Usuario;
  envioCorreo: boolean;
  mensajeExito: string;
  mensajeError: string;
  mensajeUsuarioNull: string;
  submitReenvioCorreo: boolean;

  constructor(private formBuldier: FormBuilder, private cdr: ChangeDetectorRef, private usuarioService: UsuarioService,
    private router: Router, private title: Title, private meta: Meta) {
    this.agregarMetaData();
    this.lang = "es";
    this.captchaIsLoaded = false;
    this.captchaSuccess = false;
    this.captchaIsExpired = false;
    this.calveSitio = environment.siteKey;
    this.submitReenvioCorreo = false;
   }

  ngOnInit() {
    this.formVer = this.formBuldier.group({
        email: [null,[Validators.required, Validators.pattern(correoRegExp)]],
        recaptcha: [null, Validators.required]
    })
  }

  private agregarMetaData(): void {
    this.title.setTitle('Reenvío Código de Verificación');
    this.meta.updateTag({name: "description", content: "¿No te llego tu código de verificación? Solicita de nuevo tu código y no te pierdas de los beneficios con TG Empleos."});//falta descripcion e imagen para mostrar en open graph
    this.meta.updateTag({name: "keywords", content: "reenvio, correo, empresa, cuenta, candidato, codigo"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Reenvío Código de Verificación"});
    this.meta.updateTag({property: "og:description", content: "¿No te llego tu código de verificación? Solicita de nuevo tu código y no te pierdas de los beneficios con TG Empleos."});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Reenvío Código de Verificación"});
    this.meta.updateTag({name: "twitter:description", content:"¿No te llego tu código de verificación? Solicita de nuevo tu código y no te pierdas de los beneficios con TG Empleos."});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }
  async enviarCorreo(){
    this.envioCorreo = true;
    if(this.formVer.valid && this.formVer.value.recaptcha){
        this.usuario = await this.existeUsuarioPorCorreo(this.formVer.value.email);
        if (!this.usuario) {
            this.mensajeUsuarioNull = "Lo sentimos, el correo ingresado no existe. Verifique el correo";
            this.reiniciarMensaje();
        }
        else {
            this.submitReenvioCorreo = true;
            this.usuarioService.reenvioCorreo(this.usuario).pipe(
                catchError(error => {
                    let mensajeError = '';
                if (error.status === 0) {
                    mensajeError = 'Error: se ha producido un error: '+ error.error + '/n'
                    mensajeError += `Http error: ${error.message}`;
                    console.error('se ha producido un error:', error.error);
                }else{
                    mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.messageError}.\n`;
                    mensajeError += `Http error: ${error.message}`;
                    this.mensajeError = error.error.message;
                    console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
                }
                this.handleReset();
                this.handleLoad();
                this.reiniciarMensaje();
                return throwError(mensajeError);
                })
            ).subscribe(result => {
                this.envioCorreo = result.success;
                if(result.success){
                    this.mensajeExito = 'Éxito Se ha reenviado el correo correctamente.';
                }else{
                    this.mensajeExito = 'Error se ha producido un error al mandar el correo, intentelo más tarde.';
                    console.error('Error enviar correo: ', result.messageError);
                }
                this.reiniciarMensaje();
                setTimeout(() => {
                    this.router.navigate([`/acceder`]);
                   }, 5000);
                this.handleReset();
                this.handleLoad();
            })
        }
    }else {
        if(!this.formVer.value.recaptcha){
            this.mensajeError = "Falta llenar el campo captcha. Favor de seleccionarlo";
        }
        this.reiniciarMensaje();
    }
  }

  private async existeUsuarioPorCorreo(correo: string) {
    try {
      const response = await this.usuarioService.obtenerUsuarioExistente(correo);
      return response.data;
    } catch (error) {
      console.error("Error al traer usuario existente", error);
    }
  }

  reiniciarMensaje(){
    setTimeout(() => {
        this.mensajeError = "" as string;
        this.mensajeExito = "" as string;
        this.mensajeUsuarioNull = "" as string;
        this.submitReenvioCorreo = false;
        this.envioCorreo = false;
       }, 5000);
  }

  handleError(): void {
    this.cdr.detectChanges();
  }

  handleReset(): void {
    this.captchaSuccess = false;
    this.captchaResponse = undefined;
    this.captchaIsExpired = false;
    this.cdr.detectChanges();
  }

  handleLoad(): void {
    this.captchaIsLoaded = true;
    this.captchaIsExpired = false;
    this.cdr.detectChanges();
  }

  handleExpire(): void {
    this.captchaSuccess = false;
    this.captchaIsExpired = true;
    this.cdr.detectChanges();
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    this.captchaIsExpired = false;
  }

}
